<template>
  <v-app id="inspire">
    <v-snackbar v-model="flag" top color="error" v-if="!validReset">
      {{ message }}
      <v-btn color="white" text @click="flag = false">Close</v-btn
    ></v-snackbar>

    <v-layout row wrap>
      <v-flex sm12 md6>
        <v-img src="../assets/logo-B.jpg" :aspect-ratio="1"></v-img>
        <p class="text-center">Climate RX v.1.20.2022</p>
      </v-flex>
      <v-flex sm12 md6 id="forgot-password-card">
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="9">
            <v-card class="elevation-12">
              <v-toolbar dark flat>
                <v-toolbar-title>FORGOT PASSWORD</v-toolbar-title>
              </v-toolbar>
              <template v-if="validReset">
                <v-card-text class="px-4 py-4">
                  <v-icon large color="teal darken-2">
                    mdi-email
                  </v-icon>
                  <h2 class="d-inline-block align-sub ml-4 mb-4">Email sent</h2>
                  <p>An email has been sent to <span class="font-weight-bold">{{ message }}</span> with further instructions.</p>
                </v-card-text>
              </template>
              <template v-else>
                <v-card-text>
                  <v-form ref="form" v-model="valid" lazy-validation>
                    <label>Email</label>
                    <v-text-field
                      name="email"
                      required
                      v-model="email"
                      :rules="emailRules"
                      prepend-icon="mdi-email"
                      type="text"
                      v-on:keydown.enter.prevent="onEnterKey"
                    ></v-text-field>
                  </v-form>
                </v-card-text>
                <v-card-actions>
                  <router-link to="/" class="primary--text subtitle-2 text-decoration-underline">Back to login</router-link>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="white--text mr-2"
                    color="#2b3990"
                    @click="sendPasswordResetInstructions"
                  >
                    Send Reset Instructions<Loader v-if="loading" />
                  </v-btn>
                </v-card-actions>
              </template>
            </v-card>
          </v-col>
        </v-row>
      </v-flex>
    </v-layout>
  </v-app>
</template>

<script>
  import { mapActions } from "vuex";
  import Loader from "@/components/Spinner.vue";

  export default {
    name: "ForgotPassword",
    components: { Loader },
    data() {
      return {
        valid: true,
        loading: false,
        flag: false,
        email: "",
        message: "",
        emailRules: [
          (v) => !!v || "E-mail is required",
          (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
        ],
        validReset: false,
      }
    },
    methods: {
      ...mapActions(["resetPassword"]),

      validate() {
        return this.$refs.form.validate();
      },

      onEnterKey: function(e) {
        if (e.keyCode === 13) {
          this.sendPasswordResetInstructions();
        }
      },

      sendPasswordResetInstructions() {
        this.loading = true;

        if (this.validate()) {
          this.resetPassword({ Email: this.email })
            .then((res) => {
              if (!res.data.success) {
                this.flag = true;
                this.loading = false;
                this.message = res.data.msg;

                return;
              } else {
                this.loading = false;
                this.validReset = true;
                this.message = res.data.msg;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          this.loading = false;
        }
      }
    }
  }
</script>
<style scoped>
  #forgot-password-card {
    margin-top: auto;
    margin-bottom: auto;
  }

  .align-sub {
    vertical-align: sub;
  }

  @media only screen and (max-width: 480px) {
    #forgot-password-card {
      margin-top: -40px;
      padding-top: 0;
      margin-right: 25px;
      margin-left: 25px;
    }
  }
</style>